module.exports = {
    OWLS_FIVERR_CHOICE_EXPANSION: 2587,
};
